import sounds, { SFX } from "../../classes/Sounds";
import Sprite from "../object-graphics/Sprite";
import { TILES } from "../../helpers/tiles";
import { useRef } from "react";

export default function RestartLevelButton({ level }) {
  const buttonRef = useRef();
  return (
    <button
      ref={buttonRef}
      onClick={() => {
        sounds.playSfx(SFX.CLICK);
        level.restart();

        // Unfocus after click
        buttonRef.current.blur();
      }}
    >
      <Sprite frameCoord={TILES.RESTART_BUTTON} />
    </button>
  );
}
